// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-page, .login-page, .register-page, .settings-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px;
}

.welcome-actions {
    margin-top: 20px;
    display: flex;
}

.welcome-actions a {
    color: #2196F3;
    text-decoration: none;
    margin: 0 10px;
}

.welcome-actions .button {
    margin: 0 10px;
}
.welcome-actions .button i {
    margin-right: 5px;
}

.login-form, .register-form {
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: #1e1e1e;
}

.login-form h2, .register-form h2 {
    text-align: center;
    margin-bottom: 20px;
}

.login-form .error-message, .register-form .error-message {
    color: #f44336;
    text-align: center;
    margin-bottom: 10px;
}

.login-form .success-message, .register-form .success-message {
    color: #4CAF50;
    text-align: center;
    margin-bottom: 10px;
}

.login-form input, .register-form input {
    margin-bottom: 15px;
}

.login-form button, .register-form button {
    width: 100%;
    display: block;
    margin-top: 10px;
}

.login-form p, .register-form p {
    text-align: center;
    margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/Auth.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".welcome-page, .login-page, .register-page, .settings-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    padding: 20px;\n}\n\n.welcome-actions {\n    margin-top: 20px;\n    display: flex;\n}\n\n.welcome-actions a {\n    color: #2196F3;\n    text-decoration: none;\n    margin: 0 10px;\n}\n\n.welcome-actions .button {\n    margin: 0 10px;\n}\n.welcome-actions .button i {\n    margin-right: 5px;\n}\n\n.login-form, .register-form {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    background-color: #1e1e1e;\n}\n\n.login-form h2, .register-form h2 {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.login-form .error-message, .register-form .error-message {\n    color: #f44336;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.login-form .success-message, .register-form .success-message {\n    color: #4CAF50;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.login-form input, .register-form input {\n    margin-bottom: 15px;\n}\n\n.login-form button, .register-form button {\n    width: 100%;\n    display: block;\n    margin-top: 10px;\n}\n\n.login-form p, .register-form p {\n    text-align: center;\n    margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
